/**
 * Removes markdown code fences if the content is wrapped with ```markdown and ```
 * Only removes the fences if the first line is exactly ```markdown
 *
 * @param content - The content that may be wrapped in markdown code fences
 * @returns The content with markdown fences removed if they were present
 */
export default function stripMarkdownFences(content: string): string {
  const lines = content.split('\n');
  if (lines.length < 2) {
    return content;
  }

  const firstLine = lines[0].trim();

  if (!(firstLine === '```markdown' || firstLine === '````markdown')) return content;

  const last3Lines = lines.slice(-3);
  //remove line if it is ``` or empty line
  const last3LinesWithoutEmptyLines = last3Lines.filter((line) => line.trim() !== '' && line.trim() !== '```');

  return [...lines.slice(1, -3), ...last3LinesWithoutEmptyLines].join('\n');
}
